import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../LayoutPage/Layout/Layout';
import { AuthContext } from '../../Logica/context/AuthContext';
import { parseArchivoMaterias } from '../../../utils/admin/parseMateriasExcel';
import { parseArchivoPermissions } from '../../../utils/admin/parsePermissionsExcel';
import { authFetch } from '../../../utils/authFetch';
import './ImportarDatos.css';

function SeccionImportacion({ titulo, descripcion, parseArchivo, endpoint, aArrayParaEnviar, nombreClaveEnvio, email }) {
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [filasCargadas, setFilasCargadas] = useState([]);
  const [erroresCarga, setErroresCarga] = useState([]);
  const [enviando, setEnviando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  const handleArchivoChange = async (e) => {
    const archivo = e.target.files[0];
    setMensaje(null);
    setFilasCargadas([]);
    setErroresCarga([]);
    setNombreArchivo('');

    if (!archivo) return;

    try {
      const { filas, errores } = await parseArchivo(archivo);
      setNombreArchivo(archivo.name);
      setFilasCargadas(filas);
      setErroresCarga(errores);
    } catch (error) {
      console.error('Error al leer el Excel:', error);
      setMensaje({ tipo: 'danger', texto: 'No se pudo leer el archivo. Verifica que sea un .xlsx válido.' });
    }
  };

  const handleImportar = async () => {
    setEnviando(true);
    setMensaje(null);

    try {
      const respuesta = await authFetch(`https://api.micrositec.com/api${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, [nombreClaveEnvio]: aArrayParaEnviar(filasCargadas) }),
      });
      const data = await respuesta.json();

      if (respuesta.ok && data.ok) {
        setMensaje({ tipo: 'success', texto: data.message });
      } else {
        setMensaje({ tipo: 'danger', texto: data.message || 'No se pudo importar.' });
      }
    } catch (error) {
      console.error('Error al importar:', error);
      setMensaje({ tipo: 'danger', texto: 'Error de red al importar.' });
    }

    setEnviando(false);
  };

  const datosValidos = filasCargadas.length > 0 && erroresCarga.length === 0;

  return (
    <div className="border rounded p-3 mb-4">
      <h4>{titulo}</h4>
      <p className="text-muted">{descripcion}</p>

      <input type="file" accept=".xlsx,.xls" className="form-control mb-2" onChange={handleArchivoChange} />
      {nombreArchivo && (
        <div className="form-text">
          {nombreArchivo}: {filasCargadas.length} fila(s) cargada(s).
        </div>
      )}
      {erroresCarga.length > 0 && (
        <div className="alert alert-danger mt-2">
          <strong>El archivo tiene datos incompletos:</strong>
          <ul className="mb-0">
            {erroresCarga.slice(0, 10).map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
          {erroresCarga.length > 10 && <div>...y {erroresCarga.length - 10} más.</div>}
        </div>
      )}

      <button className="btn btn-primary mt-2" disabled={!datosValidos || enviando} onClick={handleImportar}>
        {enviando ? 'Importando...' : titulo}
      </button>

      {mensaje && <div className={`alert alert-${mensaje.tipo} mt-3`}>{mensaje.texto}</div>}
    </div>
  );
}

const ImportarDatos = () => {
  const { usuario, estadoUsuario, userType } = useContext(AuthContext);
  const esAdmin = userType?.toLowerCase() === 'admin';

  if (estadoUsuario !== 'autorizado' || !esAdmin) {
    return (
      <Layout mostrarAside={false}>
        <div className="container mt-1">
          <h2>Importar datos</h2>
          {estadoUsuario === 'cargando' ? (
            <p>Cargando...</p>
          ) : estadoUsuario === 'autorizado' ? (
            <div className="alert alert-danger">No tienes permiso para ver esta página.</div>
          ) : (
            <div className="alert alert-warning">Inicia sesión como administrador para ver esta página.</div>
          )}
        </div>
      </Layout>
    );
  }

  return (
    <Layout mostrarAside={false}>
      <div className="container mt-1">
        <Link to="/" className="btn btn-link ps-0 mb-2 text-decoration-none">
          ← Volver al inicio
        </Link>
        <h2>Importar datos</h2>

        <SeccionImportacion
          titulo="Importar materias"
          descripcion='Excel con: ID, CODE, NAME, GROUP, MON, TUE, WED, THU, FRI, BEGIN, END, CATEGORY ("Cultura" o "Deporte"), CAPACITY. Si el ID ya existe, se actualiza (el número de inscritos no se toca).'
          parseArchivo={parseArchivoMaterias}
          endpoint="/admin/materias"
          nombreClaveEnvio="materias"
          aArrayParaEnviar={(filas) => filas.map(({ fila, ...resto }) => resto)}
          email={usuario.email}
        />

        <SeccionImportacion
          titulo="Importar permisos"
          descripcion="Excel con: ID, PERMISSION, MAIL. El nombre (NAME) se guarda igual al ID. Si el ID ya existe, se actualiza (no se toca si ya está registrado ni su tipo de usuario)."
          parseArchivo={parseArchivoPermissions}
          endpoint="/admin/permissions"
          nombreClaveEnvio="permisos"
          aArrayParaEnviar={(filas) => filas.map(({ fila, ...resto }) => resto)}
          email={usuario.email}
        />
      </div>
    </Layout>
  );
};

export default ImportarDatos;
